import { tokens } from "@fluentui/react-components";
import * as React from "react";
import type { TestHistoryPoint } from "../types/ProjectDashboard.types";
import { DisplayTestStatus } from "../types/TestCasesTab.types";
import { useTestSparklineStyles } from "../styles/testSparkline.styles";

interface TestSparklineProps {
    history: TestHistoryPoint[];
    maxPoints?: number;
}

import { primer } from "../styles/primerDarkTheme";

const STATUS_COLORS: Record<string, string> = {
    [DisplayTestStatus.Passed]:    primer.green,
    [DisplayTestStatus.Flaky]:     primer.flakyYellow,
    [DisplayTestStatus.Failed]:    primer.orange,
    [DisplayTestStatus.Skipped]:   primer.red,
    [DisplayTestStatus.NoResults]: tokens.colorNeutralStroke2,
    [DisplayTestStatus.Unknown]:   tokens.colorNeutralStroke2,
};

const TestSparkline: React.FC<TestSparklineProps> = ({ history, maxPoints = 10 }) => {
    const s = useTestSparklineStyles();
    if (!history || history.length === 0) {
        return <span className={s.empty}>—</span>;
    }
    const points = history.slice(-maxPoints);
    const barWidth = 4;
    const barHeight = 12;
    const barGap = 3;
    const barRadius = 1;
    const svgWidth = points.length * (barWidth + barGap) - barGap;
    const svgHeight = barHeight;
    return (
        <svg width={svgWidth} height={svgHeight} viewBox={`0 0 ${svgWidth} ${svgHeight}`} className={s.svg}>
            {points.map((point, i) => (
                <rect
                    key={`${point.runId}-${i}`}
                    x={i * (barWidth + barGap)}
                    y={0}
                    width={barWidth}
                    height={barHeight}
                    rx={barRadius}
                    ry={barRadius}
                    fill={STATUS_COLORS[point.status] ?? tokens.colorNeutralStroke2}
                />
            ))}
        </svg>
    );
};

export default TestSparkline;
